"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarDropDownItemTemplateCreator = exports.ToolbarItemTemplateCreator = void 0;
var tslib_1 = require("tslib");
var ToolbarItemTemplateCreator = (function () {
    function ToolbarItemTemplateCreator() {
    }
    ToolbarItemTemplateCreator.prototype.createTemplate = function () {
        return {
            location: 'before',
            locateInMenu: 'auto'
        };
    };
    ToolbarItemTemplateCreator.prototype.getCssClass = function () {
        return 'dx-ribbon-item';
    };
    ToolbarItemTemplateCreator.prototype.shouldCreateTextContentTemplate = function (textOptions) {
        return textOptions && textOptions.text && textOptions.text != '';
    };
    ToolbarItemTemplateCreator.prototype.createTextContentTemplate = function (textOptions, widgetOptions, type) {
        return function (_data, _index, _element) {
            var container = document.createElement("div");
            var boxElement = document.createElement("div");
            boxElement.style.display = 'inline-block';
            var textElement = document.createElement("div");
            textElement.style.display = 'inline-block';
            textElement.textContent = textOptions.text;
            if (!textOptions.displayAfterEditor)
                container.appendChild(textElement);
            container.appendChild(boxElement);
            if (textOptions.displayAfterEditor)
                container.appendChild(textElement);
            new type(boxElement, widgetOptions);
            return container;
        };
    };
    return ToolbarItemTemplateCreator;
}());
exports.ToolbarItemTemplateCreator = ToolbarItemTemplateCreator;
var ToolbarDropDownItemTemplateCreator = (function (_super) {
    tslib_1.__extends(ToolbarDropDownItemTemplateCreator, _super);
    function ToolbarDropDownItemTemplateCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarDropDownItemTemplateCreator.prototype.getOnFocusOut = function () {
        return function (e) { return e.component.close(); };
    };
    ToolbarDropDownItemTemplateCreator.prototype.getOnKeyDown = function () {
        return function (e) {
            if (e.event.keyCode === 9)
                e.event.preventDefault();
        };
    };
    return ToolbarDropDownItemTemplateCreator;
}(ToolbarItemTemplateCreator));
exports.ToolbarDropDownItemTemplateCreator = ToolbarDropDownItemTemplateCreator;
